export const NEW_ENVIRONMENT_BASE_PATH = '/#'
